<!-- 
  name: 待分配案件
  desc: 催收模块-待分配案件
  auth: dhx
  update: 2024/2/22
 -->
<template>
  <div class="allocated-package d-c-c">
    <div class="allocated-wrapper">
      <div class="allocated-title d-s-c d-r">
        <i class="el-icon-s-data"></i>
        <h2>待分配案件管理</h2>
      </div>

      <table class="allocated-table">
        <tr v-for="(item, index) in list" :key="index">
          <td class="table-key">{{ item.name }}</td>
          <td>
            {{ item.value }}
          </td>
          <td v-if="item.button" :rowspan="list.length">
            <el-button :disabled="state[item.button.disabledKey]" :type="state.type" size="small" @click="openModel">
              点击分配案件
            </el-button>
          </td>
        </tr>
      </table>
    </div>

    <allocated-model ref="dialogRef" @parent-method="parentMethod"></allocated-model>
  </div> 
</template>

<script>
import options from './contact.js'
export default options;
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>



// WEBPACK FOOTER //
// src/views/collection/allocated_cases/index.vue